import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import FaultCodeManagement from "./FaultCodeManagement";
import CountryRegionDomainManagement from "./CountryRegionDomainManagement";
import "./style.css";

const Administration: React.FC = () => {
  const [activeTab, setActiveTab] = useState("faultCodes");

  return (
    <div className="administration-container">
      <h2 className="page-title">Administration</h2>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k || "faultCodes")}
        className="mb-3 administration-tabs"
      >
        <Tab eventKey="faultCodes" title="Fault Codes">
          <FaultCodeManagement />
        </Tab>
        <Tab eventKey="countryRegionDomains" title="Country Region Domains">
          <CountryRegionDomainManagement />
        </Tab>
        {/* Add more tabs here as needed */}
      </Tabs>
    </div>
  );
};

export default Administration;
